import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'methodology',
  templateUrl: './methodology.component.html',
  styleUrls: ['./methodology.component.scss']
})
export class MethodologyComponent implements OnInit {

  methods = [
    {
      title: '100% Personalizado, do básico ao avançado',
      description: 'Nossa tecnologia analisa seu perfil e te direciona para as aulas feitas para o seu nível e objetivo.',
      image: 'interactive.png',
    },
    {
      title: 'Tecnologia + contato humano',
      description: 'Converse individualmente com seu professor, tire dúvidas e tenha exercícios corrigidos.',
      image: 'contact.png',
    },
    {
      title: 'Estude a hora \n que quiser',
      description: 'Conteúdo disponível 24h por dia. Pratique de acordo com sua disponibilidade!',
      image: 'calendar.png',
    },
    {
      title: 'Todos os cursos em 1 só assinatura',
      description: 'Tenha uma formação completa e mude seu foco de estudo a qualquer momento!',
      image: 'certificate.png',
    },
  ]
  constructor() { }

  ngOnInit() {
  }

}
